import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";
import { SearchX } from "lucide-react";
import { Button } from "@/components/ui/button";

const SearchResults = () => {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(true);
    api.get(`/products?search=${encodeURIComponent(q)}`).then((r) => { setResults(r.data); setLoading(false); }).catch(() => setLoading(false));
  }, [q]);
  return (
    <div className="mx-auto max-w-7xl px-4 py-10 md:px-6" data-testid="search-results">
      <h1 className="font-serif text-3xl text-burgundy">Search results for "{q}"</h1>
      <p className="mt-1 text-sm text-muted-text">{results.length} products found</p>
      {loading ? <p className="py-16 text-center">Loading...</p> : results.length === 0 ? (
        <div className="flex flex-col items-center gap-3 py-24 text-center" data-testid="no-search-results">
          <SearchX className="h-12 w-12 text-muted-text/40" />
          <p className="font-serif text-2xl text-charcoal">Your style search came up empty.</p>
          <p className="text-sm text-muted-text">Try searching for kurtis, dresses or footwear.</p>
          <Button asChild className="rounded-none bg-burgundy"><Link to="/new-arrivals">Browse New Arrivals</Link></Button>
        </div>
      ) : (
        <div className="mt-8 grid grid-cols-2 gap-x-4 gap-y-8 md:grid-cols-4">{results.map((p) => <ProductCard key={p.id} product={p} />)}</div>
      )}
    </div>
  );
};

export default SearchResults;
